<template>
  <ion-page>
    <ion-header class="ion-no-border" translucent>
      <ion-toolbar class="-not-fixed">
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
        </ion-buttons>
        <ion-button
          @click="$store.commit('setOpenMenu', true)"
          slot="end"
          fill="clear"
          size="large"
          ><ion-icon
            slot="icon-only"
            :src="require('@lib/assets/icons/menu.svg')"
            size="large"></ion-icon
        ></ion-button>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen class="ion-padding">
      <ion-grid fixed>
        <ion-icon :src="require('@lib/assets/icons/roodie.svg')" size="large" />
        <div class="ion-margin-top ion-margin-bottom">
          <h1>Ihr Roodie.Check</h1>
        </div>
        <template v-if="Object.keys(roodieCheck).length">
          <ion-row class="ion-align-items-center">
            <ion-col>
              <b>{{ roodieCheck.Name }}</b>
            </ion-col>
            <ion-col size="auto">
              <ion-button
                fill="clear"
                size="small"
                @click="openRenameCheckModal = true">
                <ion-icon slot="icon-only" :icon="pencil"></ion-icon>
              </ion-button>
            </ion-col>
          </ion-row>
          <div>
            {{
              dateFormatter.formatDate(
                new Date(
                  $store.state.roodieChecks[id]?.Date?.replace(" ", "T")
                ),
                "DD.MM.YYYY HH:mm"
              )
            }}
          </div>

          <!-- <div class="ion-text-right ion-margin-top ion-padding-top">
          <ion-button @click="submit">Teilen mit {{ name }}</ion-button>
        </div> -->
          <div class="ion-text-right ion-margin-top">
            <!-- <ion-button
            fill="clear"
            size="large"
            class="ion-no-padding ion-margin-end"
            ><ion-icon
              size="large"
              :src="require('@lib/assets/icons/print-circle.svg')"
              slot="icon-only"
          /></ion-button>
          <ion-button
            fill="clear"
            size="large"
            class="ion-no-padding ion-margin-end"
            ><ion-icon
              size="large"
              :src="require('@lib/assets/icons/download-circle.svg')"
              slot="icon-only"
          /></ion-button> -->
            <ion-button
              v-if="showShareRoodieCheck"
              fill="outline"
              size="large"
              @click="shareRoodieCheck"
              ><ion-icon :icon="shareSocialOutline" slot="icon-only"
            /></ion-button>
            <ion-button
              fill="outline"
              size="large"
              @click="getSharedRoodieCheck"
              class="gtm-download-check"
              ><ion-icon :icon="cloudDownloadOutline" slot="icon-only"
            /></ion-button>
            <ion-button
              fill="outline"
              size="large"
              @click="openDeleteCheckModal"
              ><ion-icon :icon="trashOutline" slot="icon-only"
            /></ion-button>
            <!-- <ion-button fill="outline" @click="window.location.reload()"
            >Neu Starten</ion-button
          > -->
          </div>

          <ion-grid class="ion-margin-top">
            <template
              v-for="(answer, answerIndex) in roodieCheck.Data"
              :key="answerIndex">
              <ion-row class="ion-align-items-center">
                <ion-col size="12" v-html="getQuestionText(answer.question)">
                </ion-col>
                <!-- <ion-col size="2" class="ion-text-center">
                <ion-button
                  @click="editQuestion(question.id)"
                  fill="clear"
                  class="ion-no-padding"
                >
                  <ion-icon
                    slot="icon-only"
                    :src="require('@lib/assets/icons/pencil-circle.svg')"
                  ></ion-icon>
                </ion-button>
              </ion-col> -->
                <ion-col size="12">
                  <ion-text
                    color="primary"
                    v-if="!answer.base64"
                    v-html="getAnswerValue(answer)"
                    class="u-cursor-pointer"></ion-text>
                  <div v-else>
                    <img
                      height="200"
                      :src="answer.base64"
                      class="u-cursor-pointer" />
                  </div>
                </ion-col>
                <ion-col
                  v-if="!roodieCheck.Data[answerIndex + 1]?.isAdditionalAnswer"
                  size="12">
                  <div class="c-line -short"></div>
                </ion-col>
              </ion-row>
            </template>
          </ion-grid>
        </template>
      </ion-grid>
    </ion-content>
    <ion-modal
      :is-open="openRenameCheckModal"
      :css-class="['c-autoheight-modal']"
      @didDismiss="openRenameCheckModal = false">
      <ion-page>
        <div class="ion-padding modal-content ion-text-center">
          <modal-close />
          <roodie fillOuter="#5E58BE" :expression="'happy'" />
          <h6>Namen ändern</h6>
          <div class="ion-margin-vertical">
            <ion-input v-model="checkName" type="text"></ion-input>
          </div>
          <ion-button @click="renameCheck">Speichern</ion-button>
        </div>
      </ion-page>
    </ion-modal>
  </ion-page>
</template>

<script>
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonContent,
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
  IonText,
  modalController,
  IonModal,
  IonInput,
  IonBackButton,
} from "@ionic/vue";
import {
  chevronBack,
  trashOutline,
  shareSocialOutline,
  cloudDownloadOutline,
  pencil,
} from "ionicons/icons";
import axios from "@/plugins/axios";
import { DateFormatter } from "@/utils/basics/date";
import AlertModal from "@/components/AlertModal";
import Roodie from "@lib/components/svg/Roodie";
import ModalClose from "@lib/components/ModalClose";
import { Share } from "@capacitor/share";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { FileOpener } from "@awesome-cordova-plugins/file-opener";
import { Capacitor } from "@capacitor/core";
import { appOrigin } from "@/utils/basics";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonContent,
    IonButton,
    IonIcon,
    IonGrid,
    IonRow,
    IonCol,
    IonText,
    IonModal,
    IonInput,
    Roodie,
    ModalClose,
    IonBackButton,
  },
  // props: {
  //   id: {
  //     required: true,
  //     type: String,
  //   },
  // },
  data() {
    return {
      dateFormatter: DateFormatter,
      openRenameCheckModal: false,
      checkName: "",
      showShareRoodieCheck: false,
      roodieCheck: {},
    };
  },
  ionViewWillEnter() {
    this.getChecks();
    Share.canShare().then(({ value }) => {
      if (value) {
        this.showShareRoodieCheck = true;
      }
    });
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    ztkBookingLocation() {
      const foundData = this.roodieCheck.Data.find((obj) => {
        return obj.id === "zt-4";
      });
      return foundData?.valueIds;
    },
    //   roodieCheck() {
    //     return this.$store.state.roodieChecks[this.id]
    //       ? this.$store.state.roodieChecks[this.id]
    //       : {};
    //   },
  },
  methods: {
    getAnswerValue(answer) {
      let result = answer.value;
      if (answer.id === "zt-4") {
        result = `
          <b>Zahnärztliche Tagesklinik ${this.ztkBookingLocation.name}</b>
          <br />
          ${this.ztkBookingLocation.address.street} ${this.ztkBookingLocation.address.housenumber}
          <br />
          ${this.ztkBookingLocation.address.zip} -
          ${this.ztkBookingLocation.address.city}
        `;
      } else if (answer.value === "ZTK") {
        result = "Zahnärztliche Tageskliniken";
      } else if (answer.value.startsWith("ARAG Case Management")) {
        result = "ARAG Gesundheitsassistenten";
      }
      return result;
    },
    async getChecks(force = false) {
      // if (force || !this.$store.state.roodieChecks[this.id]) {
      //   this.$store.commit("setShowLoading", true);
      //   const response = await axios.post("?Mode=General&Function=GetChecks", {
      //     Json: {},
      //     Name: " ",
      //   });
      //   if (response.data.Status === "Success") {
      //     this.$store.commit("setRoodieChecks", response.data.Result);
      //   }
      // }
      // this.checkName = this.$store.state.roodieChecks[this.id]?.Name;

      if (force || !this.$store.state.roodieChecks[this.id]) {
        this.$store.commit("setShowLoading", true);
        const response = await axios.post("?Mode=General&Function=GetCheck", {
          Id: this.id,
        });
        if (response.data.Status === "Success") {
          this.roodieCheck = response.data.Result;
        }
      } else {
        this.roodieCheck = this.$store.state.roodieChecks[this.id];
      }
      if (this.roodieCheck.Data?.[0].value === "Zahn - Vorsorgetermin") {
        this.roodieCheck.Data[0].value = "Vorsorgetermin";
      }
      this.checkName = this.roodieCheck.Name;
    },
    async renameCheck() {
      this.$store.commit("setShowLoading", true);
      const response = await axios.post("?Mode=General&Function=RenameCheck", {
        Id: this.roodieCheck.Id,
        Name: this.checkName,
      });
      if (response.data.Status === "Success") {
        this.getChecks(true);
        this.openRenameCheckModal = false;
      }
    },
    async shareRoodieCheck() {
      this.$store.commit("setShowLoading", true);
      const response = await axios.post(
        "?Mode=General&Function=ShareRoodieCheck",
        {
          Id: this.roodieCheck.Id,
        }
      );
      if (response.data.Status === "Success") {
        await Share.share({
          title: response.data.Result.Title,
          text: response.data.Result.Text,
          url: response.data.Result.Url,
          dialogTitle: "Roodie.Check teilen",
        });
      }
    },
    async getSharedRoodieCheck() {
      if (Capacitor.isNativePlatform()) {
        this.$store.commit("setShowLoading", true);
        const response = await axios.post(
          "?Mode=General&Function=DownloadCheck",
          {
            Id: this.roodieCheck.Id,
            Base64: true,
          }
        );
        this.$store.commit("setShowLoading", true);
        const writeFileResult = await Filesystem.writeFile({
          path: "roodiecheck.pdf",
          data: response.data,
          directory: Directory.External,
          // encoding: Encoding.UTF8,
        });
        await FileOpener.open(writeFileResult.uri, "application/pdf");
        this.$store.commit("setShowLoading", false);
      } else {
        window.open(
          appOrigin +
            "/arag/api/?Mode=General&Function=DownloadCheck&Id=" +
            this.roodieCheck.Id,
          "_blank"
        );
      }
    },
    async openDeleteCheckModal() {
      const modal = await modalController.create({
        component: AlertModal,
        cssClass: "c-autoheight-modal",
        componentProps: {
          message: "Möchten Sie den Roodie.Check wirklich löschen?",
          buttons: ["Ja", "Nein"],
        },
      });
      modal.onDidDismiss().then((data) => {
        if (data.data?.button === "Ja") {
          this.deleteCheck();
        }
      });
      return modal.present();
    },
    async deleteCheck() {
      this.$store.commit("setShowLoading", true);
      const response = await axios.post("?Mode=General&Function=DeleteCheck", {
        Id: this.id,
      });
      if (response.data.Status === "Success") {
        const modal = await modalController.create({
          component: AlertModal,
          cssClass: "c-autoheight-modal",
          componentProps: {
            message: "Der Roodie.Check wurde erfolgreich gelöscht.",
            buttons: ["Ok"],
          },
        });
        modal.onDidDismiss().then(() => {
          this.$router.replace({ name: "roodie-checks" });
        });
        return modal.present();
      }
    },
    getQuestionText(question) {
      let result = "";
      if (question?.summary?.text) {
        result = question.summary.text;
      } else if (typeof question.text === "object") {
        // if (question.text.zahn && this.zahn) {
        //   result = question.text.zahn;
        // } else
        if (question.text.all) {
          result = question.text.all;
        }
      } else {
        result = question.text;
      }
      return result;
    },
  },
  setup() {
    return {
      chevronBack,
      trashOutline,
      shareSocialOutline,
      cloudDownloadOutline,
      pencil,
    };
  },
};
</script>

<style></style>
